module.exports = {"id":"235889","name":"Cengiz Ünder","rating":"76","photo":"./data/images/photos/2/235889.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["AD","AG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CengizUnder0.json
// module id = 747
// module chunks = 0